import FieldsInput from "../../../../components/FieldComponents/FieldsInput";
import { useTranslation } from "react-i18next";
import { mergeClasses } from "@fluentui/react-components";
import Style from "../AddProject.style";
import { Stack } from "@fluentui/react";

const DesignTeam = (props) => {
  const { designTeam } = props;
  const { t } = useTranslation();
  const style = Style();
  return (
    <>
      <Stack className={style.client_field}>
        <FieldsInput
          label={t('project.design_team')}
          validationMessage={props.errors?.designTeam?.message}
          id="designTeam"
          placeholder={t('project.enter_design_team')}
          name="designTeam"
          inputDefaultValue={designTeam}
          inputClassName={mergeClasses(style.textboxInput)}
          noRequired
          validation={props.register("designTeam")}
        />
      </Stack>
    </>
  );
};

export default DesignTeam;
